import { VPS_API_URL } from "./authConfig";
export class VpsError extends Error {
    constructor(status, message) {
        super(message);
        this.status = status;
        this.name = "VpsError";
    }
}
async function handleResponse(response) {
    if (!response.ok) {
        // B-43: session expirée — message explicite pour HTTP 401
        if (response.status === 401) {
            throw new VpsError(401, "Votre session a expiré. Veuillez recharger la page pour vous reconnecter.");
        }
        // B-19: message utilisateur sans jargon technique
        const isServerError = response.status >= 500;
        let errorMessage = isServerError
            ? "Certaines données n'ont pas pu être chargées. Réessayez ou contactez l'administrateur."
            : `Erreur (${response.status})`;
        try {
            const body = await response.json();
            if (body?.detail) {
                if (typeof body.detail === "string") {
                    errorMessage = body.detail;
                }
                else if (Array.isArray(body.detail)) {
                    // B-46: humaniser les erreurs de validation Pydantic (422)
                    const FIELD_LABELS = {
                        code_unique: "Code unique", prenom: "Prénom", nom: "Nom",
                        upn_propose: "UPN proposé", date_arrivee: "Date d'arrivée",
                        categorie: "Catégorie", lieu: "Lieu", service: "Service",
                        type_machine: "Type de machine", licence_o365: "Licence O365",
                    };
                    const msgs = body.detail.map((e) => {
                        const loc = e.loc ?? [];
                        const field = loc.length > 0 ? loc[loc.length - 1] : "";
                        const label = FIELD_LABELS[field] ?? field;
                        const msg = e.msg ?? "invalide";
                        return label ? `${label} : ${msg}` : msg;
                    });
                    errorMessage = `Données incorrectes : ${msgs.join(", ")}`;
                }
                else {
                    errorMessage = JSON.stringify(body.detail);
                }
            }
            else if (body?.message) {
                errorMessage = body.message;
            }
        }
        catch { /* ignore */ }
        throw new VpsError(response.status, errorMessage);
    }
    // 204 No Content — pas de corps à parser
    if (response.status === 204)
        return undefined;
    return response.json();
}
function buildHeaders(apiToken) {
    return {
        Authorization: `Bearer ${apiToken}`,
        "Content-Type": "application/json",
    };
}
/**
 * GET /api/...
 * path doit commencer par /api/
 */
export async function vpsGet(path, apiToken) {
    const response = await fetch(`${VPS_API_URL}${path}`, {
        headers: buildHeaders(apiToken),
    });
    return handleResponse(response);
}
/**
 * POST /api/...
 */
export async function vpsPost(path, body, apiToken) {
    const response = await fetch(`${VPS_API_URL}${path}`, {
        method: "POST",
        headers: buildHeaders(apiToken),
        body: JSON.stringify(body),
    });
    return handleResponse(response);
}
/**
 * PATCH /api/...
 */
export async function vpsPatch(path, body, apiToken) {
    const response = await fetch(`${VPS_API_URL}${path}`, {
        method: "PATCH",
        headers: buildHeaders(apiToken),
        body: JSON.stringify(body),
    });
    return handleResponse(response);
}
/**
 * PUT /api/...
 */
export async function vpsPut(path, body, apiToken) {
    const response = await fetch(`${VPS_API_URL}${path}`, {
        method: "PUT",
        headers: buildHeaders(apiToken),
        body: JSON.stringify(body),
    });
    return handleResponse(response);
}
/**
 * DELETE /api/...
 */
export async function vpsDelete(path, apiToken) {
    const response = await fetch(`${VPS_API_URL}${path}`, {
        method: "DELETE",
        headers: buildHeaders(apiToken),
    });
    if (!response.ok) {
        throw new VpsError(response.status, `Erreur suppression VPS (${response.status})`);
    }
}
